module.exports = __webpack_public_path__ + "static/media/spinner.5ff0e1c0.svg";